import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 3H3.01v18H21V3zm-5.99 14H9v-2h4v-2h-2v-2h2V9H9V7h6.01v10z"
}), 'Looks3Sharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Looks3Sharp.js
// module id = 4710
// module chunks = 2